module.exports = __webpack_public_path__ + "img/Arab1.bf83be87.jpg";